import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'
import { mdiAccountGroup } from '@mdi/js'
import { FunctionComponent } from 'react'

export const IconSharedLibrary: FunctionComponent<SvgIconProps> = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d={mdiAccountGroup} />
	</SvgIcon>
)
